import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { environment } from '../../../environments/environment';

@Pipe({
    name: 'safeUrl',
    standalone: false
})
export class SafeUrlPipe implements PipeTransform {

  private readonly origenPermitido = new URL(environment.geoSuraBaseUrl).origin;

  constructor(private readonly sanitizer: DomSanitizer) { }

  transform(url: string): SafeResourceUrl | null {
    if (!this.esUrlPermitida(url)) {
      return null;
    }
    // Solo se confía en URLs https del origen de GeoSura configurado en el environment.
    return this.sanitizer.bypassSecurityTrustResourceUrl(url); // NOSONAR: URL validada contra el origen permitido
  }

  private esUrlPermitida(url: string): boolean {
    try {
      const destino = new URL(url);
      return destino.protocol === 'https:' && destino.origin === this.origenPermitido;
    } catch {
      return false;
    }
  }

}
